import MindsetsJsSDK, {ErrorMessageAction} from "../../index";
import {LoadingAction} from "../layout/actions";

export const LOADED_RESPONSES = '[responses] Responses loaded';
export const LOADED_RESPONSES_PAGES = '[responses] Loaded pages';
export const LOADED_RESPONSES_TOTAL = '[responses] Loaded total';
export const LOADED_RESPONSES_CURRENT = '[responses] Loaded current';
export const LOADED_RESPONSES_LIMIT = '[responses] Loaded limit';
export const LOADED_RESPONSE = '[response] Loaded Response';

export const LoadResponsesAction = options => dispatch => {
    dispatch(LoadingAction(true, 'Loading Responses'));

    return MindsetsJsSDK().API.get('responses', options)
        .then(response => {
            dispatch(LoadedResponsesAction(response.items));
            dispatch(LoadedResponsesPagesAction(response.pages));
            dispatch(LoadedResponsesTotalAction(response.total));
            dispatch(LoadedResponsesCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedResponsesLimitAction(response.limit));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            console.error(error);
            dispatch(ErrorMessageAction(error));
        });
}
export const LoadedResponsesAction = payload => ({
    type: LOADED_RESPONSES,
    payload
});
export const LoadedResponsesPagesAction = payload => ({
    type: LOADED_RESPONSES_PAGES,
    payload
});
export const LoadedResponsesTotalAction = payload => ({
    type: LOADED_RESPONSES_TOTAL,
    payload
});
export const LoadedResponsesCurrentAction = payload => ({
    type: LOADED_RESPONSES_CURRENT,
    payload
});
export const LoadedResponsesLimitAction = payload => ({
    type: LOADED_RESPONSES_LIMIT,
    payload
});

export const CreateResponsesAction = (data, options) => dispatch => {
    dispatch(LoadingAction(true, 'Saving Responses'));

    return MindsetsJsSDK().API.post('responses', data, options)
        .catch(error => console.error(error))
        .then(() => dispatch(LoadingAction(false)));
}

export const LoadResponseAction = (id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Response')))
        .then(() => MindsetsJsSDK().API.get(`responses/${id}`, options))
        .then(response => {
            dispatch(LoadedResponseAction(response.response));
            dispatch(LoadingAction(false))

            return response.response;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedResponseAction = payload => ({
    type: LOADED_RESPONSE,
    payload
});
